import { Teams, type Team } from '../data'
import { type GetHookResponse } from '../hooks'
import { useTeams } from './list'
import { isNotEmpty, type ArchivedFilter, type TeamData } from '@terros/common'
import { type Dispatch, type SetStateAction, useState } from 'react'

export type TeamListState = GetHookResponse<TeamData[]> & {
  filtered: Team[]
  filter: string
  setFilter: Dispatch<SetStateAction<string>>
  showArchived: ArchivedFilter
  setShowArchived: Dispatch<SetStateAction<ArchivedFilter>>
}

export function useTeamListState(archived?: boolean): TeamListState {
  const [filter, setFilter] = useState('')
  const [showArchived, setShowArchived] = useState<ArchivedFilter>(Boolean(archived))
  const state = useTeams({ showArchived })
  const teams = new Teams(state.data)

  return {
    ...state,
    filtered: isNotEmpty(filter) ? teams.filter(filter) : teams.getRootTeams(),
    filter,
    setFilter,
    showArchived,
    setShowArchived,
  }
}
